import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import axios from "axios";

const JobApplicationModal = ({ job, onClose }) => {
  const modalRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
  });

  const handleBackdropClick = (e) => {
    if (modalRef.current === e.target) {
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };
  let cloudname = "dnw1ttr02";
  let preset = "wjs1zyo5";
  let resumeUrl = null;
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Upload the resume to Cloudinary first
    if (formData.resume) {
      const formDataCloudinary = new FormData();
      formDataCloudinary.append("file", formData.resume);
      formDataCloudinary.append("upload_preset", preset);

      try {
        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/${cloudname}/image/upload`,
          formDataCloudinary
        );
        console.log(response)
        resumeUrl = response?.data?.secure_url;
        console.log(resumeUrl);
      } catch (error) {
        console.error("Cloudinary upload failed:", error);
        return;
      }
    }

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      job_title: job.title,
      message: `Application for ${job.title}`,
      resume_url: resumeUrl,
    };

    // Send email with the uploaded resume URL
    emailjs
      .send("service_trfsncm", "template_uor18rv", templateParams, "0eVZuqOWuvq7jiRA4")
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          onClose();
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
      onClick={handleBackdropClick}
      ref={modalRef}
    >
      <div className="bg-white p-6 sm:p-8 rounded-md w-full max-w-xs sm:max-w-md lg:max-w-lg">
        <h2 className="text-lg sm:text-xl font-bold mb-4 text-center">
          Apply for {job.title}
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Full Name Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="name">
              Full Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm sm:text-base"
              required
            />
          </div>

          {/* Email Address Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm sm:text-base"
              required
            />
          </div>

          {/* Phone Number Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="phone">
              Phone Number
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm sm:text-base"
              required
              placeholder="Enter your phone number"
            />
          </div>

          {/* Resume Upload Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="resume">
              Upload Resume (JPG/PNG)
            </label>
            <input
              type="file"
              id="resume"
              name="resume"
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm sm:text-base"
              required
            />
          </div>

          {/* Submit and Close Buttons */}
          <div className="flex flex-col sm:flex-row justify-between mt-4">
            <button
              type="submit"
              className="py-2 px-4 bg-blue-600 text-white rounded-md mb-2 sm:mb-0 sm:w-auto"
            >
              Submit Application
            </button>
            <button
              type="button"
              onClick={onClose}
              className="py-2 px-4 bg-gray-600 text-white rounded-md sm:w-auto"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JobApplicationModal;
